var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "primary", dark: "" } },
                [
                  _vm.employeeName
                    ? _c("span", [_vm._v(_vm._s(_vm.employeeName))])
                    : _c("v-progress-circular", {
                        attrs: { indeterminate: "", dark: "" }
                      }),
                  _c("v-spacer"),
                  _c("v-icon", [_vm._v("mdi-account")]),
                  _c("v-icon", [_vm._v("mdi-pencil")])
                ],
                1
              ),
              _vm._l(_vm.empPutErrors.concat(_vm.empGetErrors), function(
                item,
                index
              ) {
                return _c(
                  "v-alert",
                  {
                    key: index,
                    staticClass: "mt-2",
                    attrs: { type: "error", dismissible: "" }
                  },
                  [_vm._v(" " + _vm._s(item.first()) + " ")]
                )
              })
            ],
            2
          ),
          _c(
            "v-col",
            {
              attrs: {
                "offset-lg": "8",
                "offset-md": "8",
                lg: "4",
                md: "4",
                cols: "12"
              }
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Employee ID",
                  disabled: "",
                  loading: _vm.empGetting,
                  value: _vm.employeeId
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "First Name", loading: _vm.empGetting },
                model: {
                  value: _vm.firstname,
                  callback: function($$v) {
                    _vm.firstname = $$v
                  },
                  expression: "firstname"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { loading: _vm.empGetting },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("span", [_vm._v("Middle Name")]),
                        _c("small", { staticClass: "grey--text ml-2" }, [
                          _vm._v("(optional)")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.middlename,
                  callback: function($$v) {
                    _vm.middlename = $$v
                  },
                  expression: "middlename"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Last Name", loading: _vm.empGetting },
                model: {
                  value: _vm.lastname,
                  callback: function($$v) {
                    _vm.lastname = $$v
                  },
                  expression: "lastname"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "6", md: "6", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  type: "email",
                  rules: [_vm.verifyEmail],
                  loading: _vm.empGetting
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("span", [_vm._v("Email")]),
                        _c("small", { staticClass: "grey--text ml-2" }, [
                          _vm._v("(optional)")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "6", md: "6", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { loading: _vm.empGetting },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("span", [_vm._v("Address")]),
                        _c("small", { staticClass: "grey--text ml-2" }, [
                          _vm._v("(optional)")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.address,
                  callback: function($$v) {
                    _vm.address = $$v
                  },
                  expression: "address"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { loading: _vm.empGetting },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("span", [_vm._v("Business No")]),
                        _c("small", { staticClass: "grey--text ml-2" }, [
                          _vm._v("(optional)")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.businessNo,
                  callback: function($$v) {
                    _vm.businessNo = $$v
                  },
                  expression: "businessNo"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { loading: _vm.empGetting },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("span", [_vm._v("Mobile No")]),
                        _c("small", { staticClass: "grey--text ml-2" }, [
                          _vm._v("(optional)")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.mobileNo,
                  callback: function($$v) {
                    _vm.mobileNo = $$v
                  },
                  expression: "mobileNo"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { loading: _vm.empGetting },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("span", [_vm._v("Home No")]),
                        _c("small", { staticClass: "grey--text ml-2" }, [
                          _vm._v("(optional)")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.homeNo,
                  callback: function($$v) {
                    _vm.homeNo = $$v
                  },
                  expression: "homeNo"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  rows: "1",
                  "no-resize": "",
                  "auto-grow": "",
                  loading: _vm.empGetting
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("span", [_vm._v("Notes")]),
                        _c("small", { staticClass: "grey--text ml-2" }, [
                          _vm._v("(optional)")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.notes,
                  callback: function($$v) {
                    _vm.notes = $$v
                  },
                  expression: "notes"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "1", md: "1", cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    dark: "",
                    block: "",
                    loading: _vm.empPutting
                  },
                  on: { click: _vm.save }
                },
                [_vm._v("Save")]
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "1", md: "1", cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "red", dark: "", block: "" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/employees")
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }